import { setInvoices, setInvoice, setLoadingInv, setErrorInv, setInvoiceItems } from "../slices/invoice";
import axios from "axios";

export const getInvoices = (dateFrom, dateTo) => async (dispatch) => {
  dispatch(setLoadingInv());
  //console.log("getTotal called with:", dateFrom, dateTo);
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post("/api/invoices/", { dateFrom, dateTo }, config);

    //const { jobs, pagination } = data;
    dispatch(setInvoices(data.invoices));
    //console.log({ bookingsFilter });
    //console.log({ jobs });
  } catch (error) {
    dispatch(
      setErrorInv(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading invoices. Please try again later"
      )
    );
  }
};
export const getInvoice = (id) => async (dispatch) => {
  //dispatch(setLoadingInv());
  //console.log("getTotal called with:", dateFrom, dateTo);
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.get(`/api/invoices/${id}`, config);

    //const { jobs, pagination } = data;
    dispatch(setInvoice(data.invoice));

    const { data: invoiceItems } = await axios.get(`/api/invoices/${id}/items`, config);

    //console.log({ invoiceItems });

    dispatch(setInvoiceItems(invoiceItems));

    //console.log({ bookingsFilter });
    //console.log({ jobs });
  } catch (error) {
    dispatch(
      setErrorInv(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading invoices. Please try again later"
      )
    );
  }
};
